// import { useNavigate, useLocation } from "react-router-dom";

// export interface NavItem {
//   id: string;
//   label: string;
//   route: string;
//   Icon: React.ComponentType<{ active?: boolean }>;
//   isCenter?: boolean;
// }

// interface BottomNavigationProps {
//   items: NavItem[];
//   className?: string;
// }

// export default function AdminBottomNavigation({
//   items,
//   className = "",
// }: BottomNavigationProps) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const activeRoute = location.pathname;

//   return (
//     <nav
//       dir="rtl"
//       className={`fixed bottom-0 left-0 right-0 z-40 ${className}`}
//     >
//       <div className="max-w-[450px] 3xl:max-w-[504px] mx-auto">
//         <div className="relative rounded-t-3xl bg-brand-50">
//           <div className="grid grid-cols-5 px-2 pb-2 pt-3">
//             {items.map((item) => (
//               <button
//                 key={item.id}
//                 onClick={() => navigate(item.route)}
//                 className="relative flex flex-col items-center gap-1 px-3 py-1 rounded-xl transition-all duration-300"
//               >
//                 <span
//                   className={`transition-all absolute ease-in duration-75 ${activeRoute === item.route ? " -top-9 text-white bg-brand-700 rounded-full p-4 shadow-[0px_0px_0px_4px_#fff]" : "text-neutral-600 -top-2"}`}
//                 >
//                   <item.Icon />
//                 </span>
//                 <span
//                   className={`mt-6 text-xs font-bold leading-none transition ${activeRoute === item.route ? "text-brand-600" : "text-neutral-600"}`}
//                 >
//                   {item.label}
//                 </span>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// }
import { useNavigate, useLocation } from "react-router-dom";

export interface NavItem {
  id: string;
  label: string;
  route: string;
  Icon: React.ComponentType<{ active?: boolean }>;
  isCenter?: boolean;
}

interface BottomNavigationProps {
  items: NavItem[];
  className?: string;
}

export default function AdminBottomNavigation({
  items,
  className = "",
}: BottomNavigationProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const activeRoute = location.pathname;

  return (
    <nav
      dir="rtl"
      className={`fixed bottom-5 left-0 right-0 z-40 ${className}`}
    >
      <div className="max-w-[450px] 3xl:max-w-[504px] mx-auto px-3">
        <div className="relative rounded-3xl bg-white/40 backdrop-blur-2xl border border-white/60 shadow-[0_8px_32px_rgba(0,0,0,0.12)] ring-1 ring-black/[0.03]">
          {/* براقی بالای شیشه */}
          <div className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-3xl bg-gradient-to-b from-white/60 to-transparent" />

          <div className="relative grid grid-cols-5 px-2 pb-2 pt-3">
            {items.map((item) => {
              const isActive = activeRoute === item.route;
              return (
                <button
                  key={item.id}
                  onClick={() => navigate(item.route)}
                  aria-label={item.label}
                  aria-current={isActive ? "page" : undefined}
                  className="relative flex flex-col items-center gap-1 px-3 py-1 rounded-xl transition-all duration-300 outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50"
                >
                  <span
                    className={`absolute transition-all ease-out duration-300 ${
                      isActive
                        ? "-top-10 text-white bg-gradient-to-br from-brand-500 to-brand-700 rounded-full p-4 shadow-lg shadow-brand-700/40 ring-4 ring-white/70"
                        : "text-neutral-500 -top-2"
                    }`}
                  >
                    <item.Icon />
                  </span>
                  <span
                    className={`mt-6 text-xs font-bold leading-none transition-colors duration-300 ${
                      isActive ? "text-brand-600" : "text-neutral-500"
                    }`}
                  >
                    {item.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
}